import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-notFound-knives-info-dialog',
  props: {
    visible: { type: Boolean, default: false },
    title: { default: '存在孔槽找不到刀具' },
    data: { default: () => [] },
    showViewBtn: { type: Boolean }
  },
  emits: ["update:visible", "viewDetailInfo"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', val: boolean): void
  (e: 'viewDetailInfo'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, title: string, data: string[], showViewBtn?: boolean }





const visible = computed({
  get() {
    return props.visible
  },
  set(val) {
    emit('update:visible', val)
    return true
  },
})

const confirmLoading = ref(false)
const handleOk = () => {
  visible.value = false
}

// 关闭弹窗
const handleCancel = () => {
  visible.value = false
}

// 查看详细原片信息
const handleView = () => {
  emit('viewDetailInfo')
}

return { __sfc: true,props, emit, visible, confirmLoading, handleOk, handleCancel, handleView }
}

})